import { ArrowRight } from 'iconsax-react';
import React from 'react';

interface FlipCardProps {
  image: string;
  number: string;
  title: string;
  desc: string[];
  desc2: { label: string; value: string }[];
}

const FlipCard = ({ image, number, title, desc, desc2 }: FlipCardProps) => {
  return (
    <div className="flip-card-container">
      <div className="flip-card">
        <div className="flip-card-inner">
          <div className="card-front">
            <div className="background-image">
              <img src={image} alt="flip-card-1" width={455} height={395} />
            </div>
            <div className="card-front-content">
              <div className="title-card">
                <span>[{number}]</span>
                <ArrowRight size="36" color="#344054" />
              </div>
              <div className="desc-card">
                <p className="title">{title}</p>
                <ul>
                  {desc.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="card-back">
            <ul>
              {desc2.map((item) => (
                <li key={item.label}>
                  <span className="label">{item.label} </span>
                  <span>{item.value}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      {['02', '04'].includes(number) && (
        <>
          <div className="grid-box top-left">
            <div className="line-column" />
            <div className="line-row" />
          </div>
        </>
      )}
      {['03'].includes(number) && (
        <>
          <div className="grid-box top-right">
            <div className="line-column" />
            <div className="line-row" />
          </div>
        </>
      )}
    </div>
  );
};

export default React.memo(FlipCard);
